import type { RsuiteSortType, TextMaterial } from '@@partner:types:app'

import React, { useCallback } from 'react'
import { formatDate } from '@@partner:helpers/util'

import { Link, generatePath } from 'react-router-dom'
import { Button, ButtonGroup, Tag } from 'rsuite'

import { ROUTE_TEXT_MATERIALS_EDIT } from '@@partner:config/routes'
import TextMaterialStatusLabel from '../common/TextMaterialStatusLabel'
import ResponsiveTable, { ResponsiveTableColumn } from '@components/common/ResponsiveTable/ResponsiveTable'

export interface TextMaterialsTableProps {
  brandSlug: string
  textMaterials: TextMaterial[]
  loading?: boolean
  sortColumn: string
  sortType: RsuiteSortType | undefined
  onSortColumn: (
    sortColumn: string,
    sortType: RsuiteSortType | undefined
  ) => void
}

const columns: ResponsiveTableColumn<TextMaterial>[] = [
  {
    dataKey: 'id',
    header: 'ID',
    sortable: true,
    flexGrow: 1
  },
  {
    dataKey: 'name',
    header: 'Название',
    flexGrow: 3,
    isCardTitle: true
  },
  {
    dataKey: 'status',
    header: 'Статус',
    sortable: true,
    flexGrow: 2,
    isCardBadge: true,
    render: (material) => <TextMaterialStatusLabel status={material.status} />
  },
  {
    dataKey: 'title',
    header: 'Заголовок',
    flexGrow: 3,
    render: (material) => (
      <div>
        {material.i18n?.map(translation => (
          <div key={translation.languageCode}>
            {translation.languageCode}: {translation.title}
          </div>
        ))}
      </div>
    )
  },
  {
    dataKey: 'created_at',
    header: 'Создан',
    sortable: true,
    flexGrow: 2,
    hideOnMobile: true,
    render: (material) => (
      <Tag color="blue">{formatDate(new Date(material.created_at))}</Tag>
    )
  },
  {
    dataKey: 'updated_at',
    header: 'Обновлен',
    sortable: true,
    flexGrow: 2,
    hideOnMobile: true,
    render: (material) => (
      <Tag color="blue">{formatDate(new Date(material.updated_at))}</Tag>
    )
  }
]

export default function TextMaterialsTable ({
  brandSlug,
  textMaterials = [],
  loading = false,
  sortColumn,
  sortType,
  onSortColumn
}: TextMaterialsTableProps) {
  const renderActions = useCallback((material: TextMaterial) => (
    <ButtonGroup>
      <Button
        color="cyan"
        appearance="primary"
        as={Link}
        to={generatePath(ROUTE_TEXT_MATERIALS_EDIT, {
          brandSlug,
          textId: material.id
        })}
        size="xs"
      >
        Изменить
      </Button>
    </ButtonGroup>
  ), [ brandSlug ])

  return (
    <ResponsiveTable
      data={textMaterials}
      columns={columns}
      loading={loading}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={onSortColumn}
      renderActions={renderActions}
      rowHeight={120}
    />
  )
}
